import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

// assets
import googleStore from "../Assets/Images/google-play.png";
// import appleStore from "../Assets/Images/app-store.png";
// import logo from "../Assets/Images/logo.png";
import logoEn from "../Assets/Images/logo-en.png";
import logoAr from "../Assets/Images/logo-ar.png";

// components
import LanguageBtn from "./LanguageBtn";

const Footer = ({ onOpenTermsModal }) => {
  const { language } = useSelector((state) => state.lang);
  const { t } = useTranslation();
  const location = useLocation();
  const navLinks = [
    { key: 1, name: t("navbar.home"), link: "/home" },
    { key: 2, name: t("navbar.aboutUs"), link: "/about-us" },
    { key: 3, name: t("navbar.terms"), link: "" },
    { key: 4, name: t("navbar.privacyPolicy"), link: "/privacy-policy" },
  ];

  const handleChangingPath = (path) => {
    if (location.pathname === path) {
      window.scrollTo(0, 0);
    }
  };

  return (
    <footer className="footer">
      <div className="footer__holder mx-auto">
        <ul className="footer__holder__nav-links d-flex flex-wrap align-items-center justify-content-center list-unstyled">
          {navLinks.map((ele) => (
            <li
              key={ele.key}
              className={`${language === "en" ? "lang--en" : "lang--ar"}`}
            >
              {ele.link ? (
                <Link
                  to={ele.link}
                  onClick={() => handleChangingPath(ele.link)}
                  className="text--white fsize--6 text-capitalize fw-bold"
                >
                  {ele.name}
                </Link>
              ) : (
                <button
                  type="button"
                  onClick={onOpenTermsModal}
                  className="bg-transparent border-0 outline-none shadow-none text--white fsize--6 text-capitalize fw-bold"
                >
                  {ele.name}
                </button>
              )}
            </li>
          ))}
          <li>
            <LanguageBtn />
          </li>
        </ul>
        <div dir="ltr" className="row m-0 flex-column-reverse flex-xl-row">
          <div className="col-xl-6 px-0 footer__holder__copy-rights-col d-flex justify-content-center justify-content-xl-start">
            <div className="d-flex flex-column">
              <img
                src={language === "en" ? logoEn : logoAr}
                alt="Big Scrappers logo"
                className="img-fluid d-block mx-auto"
              />
              <p className="text--white text-center fsize--6 fw-bold mb-0">
                {t("footer.bigScrappersWebsite")} <br /> 2024
              </p>
            </div>
          </div>
          <div className="footer__holder__get-app-links-col col-xl-6 px-0 d-flex justify-content-center justify-content-xl-end">
            <div className="footer__holder__get-app-links-col__holder d-flex flex-column align-items-center">
              <p className="text--white fsize--7 fw-bold text-center mb-0">
                {t("home.thirdSection.getApplication")}
              </p>
              {/* <Link to="" target="_blank"> */}
              {/* <img src={appleStore} alt="" className="d-block img-fluid" /> */}
              {/* </Link> */}
              <Link
                to="https://play.google.com/store/apps/details?id=com.nationtech.greenmattermerchant"
                target="_blank"
              >
                <img src={googleStore} alt="" className="d-block img-fluid" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
